// Name of the cookie holding the organization the user last switched to.
// OrganizationProvider owns writing it; the shared lib only reads it so that
// analytics traits describe the organization the user is actually looking at.
export const SELECTED_ORG_COOKIE = 'SelectedOrganizationId';
export function readSelectedOrganizationId() {
    if (typeof document === 'undefined')
        return undefined;
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${SELECTED_ORG_COOKIE}=([^;]+)`));
    return match === null || match === void 0 ? void 0 : match[1];
}
// Resolve the organization the user currently has selected, falling back to the
// first one when the cookie is absent or points at an org they no longer belong
// to. Mirrors the resolution OrganizationProvider performs.
export function resolveSelectedOrganization(organizations) {
    var _a;
    if (!(organizations === null || organizations === void 0 ? void 0 : organizations.length))
        return undefined;
    const selectedId = readSelectedOrganizationId();
    return (_a = organizations.find(organization => organization.organization_id === selectedId)) !== null && _a !== void 0 ? _a : organizations[0];
}
//# sourceMappingURL=selectedOrganization.js.map